import { dynamic } from '#/utils/dynamic';

export const listingModalComponentByType = {
  SHARE_LISTING: dynamic(
    () =>
      import('./ShareListing/ShareListingModal').then((module) => ({
        default: module.ShareListingModal,
      })),
    { strategy: 'always' },
  ),
  FLAG_LISTING: dynamic(
    () =>
      import('./FlagListing/FlagListingModal').then((module) => ({
        default: module.FlagListingModal,
      })),
    { strategy: 'always' },
  ),
  EMAIL_ALERT: dynamic(
    () =>
      import('./EmailAlert/EmailAlertModal').then((module) => ({
        default: module.EmailAlertModal,
      })),
    { strategy: 'always' },
  ),
  ADMIN_REQUEST: dynamic(
    () =>
      import('./AdminRequest/AdminRequestModal').then((module) => ({
        default: module.AdminRequestModal,
      })),
    { strategy: 'always' },
  ),
  MARK_APPLIED: dynamic(
    () =>
      import('./MarkApplied/MarkAppliedModal').then((module) => ({
        default: module.MarkAppliedModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
